import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import FamilyServices from '../components/FamilyServices';
import familyRelationshipsImg from '../assets/icons/family-relationships.webp';

const FamilyRelationshipsPage = () => {
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <div className="family-relationships-page">
      <Navigation />
      
  <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="font-serif text-5xl lg:text-6xl mb-6 text-indigoDeep">
              <img src={familyRelationshipsImg} alt="Family & Relationships" className="page-header-icon" />
              Family & Relationships
            </h1>
            <p className="text-xl text-grayWarm max-w-3xl mx-auto leading-relaxed">
              Deepen your connections and heal family bonds through cosmic wisdom. 
              Discover compatibility, navigate challenges, and nurture love across all relationships.
            </p>
          </div>
        </div>
      </section>

      <FamilyServices />

      <Footer />
    </div>
  );
};

export default FamilyRelationshipsPage;
